import { CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { Checkbox } from 'components/v4';
import { Box } from '@chakra-ui/react';

const sharedDefaultCache = new CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: 40,
    minHeight: 40,
});

const CheckboxCell = ({
    dataKey,
    parent,
    rowData,
    columnData,
    rowIndex,
    cache,
}) => {
    const cellCache = cache || sharedDefaultCache;

    if (
        !cellCache ||
        typeof cellCache.has !== 'function' ||
        typeof cellCache.set !== 'function' ||
        !parent
    ) {
        return (
            <Box
                cursor="pointer"
                padding="8px"
                display="flex"
                alignItems="center"
                height="100%">
                <Checkbox
                    isChecked={columnData.checkedArray.some(
                        (checked) => checked.id === rowData.id,
                    )}
                    pointerEvents="none"
                    sx={{ mt: 0, mb: 0 }}
                />
            </Box>
        );
    }

    return (
        <CellMeasurer
            cache={cellCache}
            columnIndex={0}
            key={`${dataKey}-${rowIndex}`}
            parent={parent}
            rowIndex={rowIndex}>
            {({ measure, registerChild }) => (
                <Box
                    ref={registerChild}
                    cursor="pointer"
                    padding="8px"
                    display="flex"
                    alignItems="center"
                    height="100%"
                    onLoad={measure}>
                    <Checkbox
                        isChecked={columnData.checkedArray.some(
                            (checked) => checked.id === rowData.id,
                        )}
                        pointerEvents="none"
                        sx={{ mt: 1, mb: 1 }}
                    />
                </Box>
            )}
        </CellMeasurer>
    );
};

export default CheckboxCell;
